import { render, staticRenderFns } from "./MarketInvoicesTableTotal.vue?vue&type=template&id=da0aad76&"
import script from "./MarketInvoicesTableTotal.vue?vue&type=script&lang=js&"
export * from "./MarketInvoicesTableTotal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports